export interface ThumbnaildetailData {
  configUUID: string;
  configName: string;
  url: string;
  bytes?: number;
  format?: string;
  dimension?:string;
}
